const Demo = () => (
  <article>
    <script src="https://survey.survicate.com/workspaces/e95b6651ec10b1881da34d75a568603c/web_surveys.js" type="text/javascript" />
    <link rel="author" href="https://survey.survicate.com/workspaces/e95b6651ec10b1881da34d75a568603c/web_surveys.js" />
  </article>
)

export default Demo;